/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReservationRequest,
  GetFutureReservations200ResponseInner,
  GetProductsFiltersParameterInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
} from '../models/index';
import {
    CreateReservationRequestFromJSON,
    CreateReservationRequestToJSON,
    GetFutureReservations200ResponseInnerFromJSON,
    GetFutureReservations200ResponseInnerToJSON,
    GetProductsFiltersParameterInnerFromJSON,
    GetProductsFiltersParameterInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
} from '../models/index';

export interface CancelReservationRequest {
    reservationId: string;
}

export interface CreateReservationOperationRequest {
    createReservationRequest: CreateReservationRequest;
}

export interface GetDayReservationsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface GetFutureReservationsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface UpdateReservationRequest {
    reservationId: string;
    createReservationRequest: CreateReservationRequest;
}

/**
 * 
 */
export class ReservationsApi extends runtime.BaseAPI {

    /**
     */
    async cancelReservationRaw(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling cancelReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelReservation(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createReservationRaw(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling createReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createReservation(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDayReservationsRaw(requestParameters: GetDayReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFutureReservations200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFutureReservations200ResponseInnerFromJSON));
    }

    /**
     */
    async getDayReservations(requestParameters: GetDayReservationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFutureReservations200ResponseInner>> {
        const response = await this.getDayReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFutureReservationsRaw(requestParameters: GetFutureReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFutureReservations200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/future`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFutureReservations200ResponseInnerFromJSON));
    }

    /**
     */
    async getFutureReservations(requestParameters: GetFutureReservationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFutureReservations200ResponseInner>> {
        const response = await this.getFutureReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateReservationRaw(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservation().'
            );
        }

        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling updateReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservation(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationRaw(requestParameters, initOverrides);
    }

}
